import { SAUDE_ROI_IMG } from '../data';

const FONTES = ['ERP', 'CRM', 'Sistema Comercial', 'Sistema de Beneficiários', 'Administradora', 'Operadora'];

const FLUXO = ['Motor de Regras', 'Elegibilidade', 'Crédito', 'Catálogo', 'Resgate'];

const OFERTAS = [
  'API REST',
  'Webhook',
  'Importação CSV',
  'SFTP',
  'Integração por arquivos',
  'Consulta de status',
  'Retorno de premiação',
];

const DASHBOARD = [
  { value: '12.458', label: 'Contratos comercializados' },
  { value: '38.920', label: 'Vidas' },
  { value: 'R$ 485.320', label: 'Premiações geradas' },
  { value: '14', label: 'Campanhas ativas' },
  { value: '1.842', label: 'Corretores participantes' },
  { value: '9.842', label: 'Contratos elegíveis' },
];

const ROI = [
  { label: 'Investimento', value: 'R$ 100 mil' },
  { label: 'Novos contratos', value: '1.250' },
  { label: 'Novas vidas', value: '3.840' },
  { label: 'Vendas geradas', value: 'R$ 4,2 mi' },
];

export default function IntegracoesDashboard() {
  return (
    <section id="resultados" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Integração e resultados
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Conecte seus sistemas e <span className="text-primary-600">meça cada campanha</span>
          </h2>
        </div>

        <div className="grid gap-5 lg:grid-cols-2">
          <article className="rounded-3xl border border-background-200 bg-background-100 p-7 md:p-8">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">Integrações com operadoras</h3>
            <div className="mt-5 flex flex-wrap gap-2">
              {FONTES.map((fonte) => (
                <span key={fonte} className="rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700">
                  {fonte}
                </span>
              ))}
            </div>
            <div className="mt-4 flex items-center justify-center gap-2 rounded-2xl bg-primary-500 px-4 py-3 text-center">
              <span className="text-sm font-semibold text-white">API / Arquivo</span>
            </div>
            <div className="mt-4 flex items-center justify-center gap-2">
              <span className="text-foreground-300">
                <i className="ri-arrow-down-line"></i>
              </span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-2">
              {FLUXO.map((item, index) => (
                <div key={item} className="flex items-center gap-2">
                  <span className="rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700">
                    {item}
                  </span>
                  {index < FLUXO.length - 1 && (
                    <span className="text-foreground-300">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  )}
                </div>
              ))}
            </div>
            <div className="mt-6">
              <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Formatos suportados</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {OFERTAS.map((oferta) => (
                  <span key={oferta} className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800">
                    <i className="ri-plug-line"></i>
                    {oferta}
                  </span>
                ))}
              </div>
            </div>
          </article>

          <article className="rounded-3xl border border-background-200 bg-background-100 p-7 md:p-8">
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">Dashboard da Operadora</h3>
            <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3">
              {DASHBOARD.map((item) => (
                <div key={item.label} className="rounded-2xl border border-background-200 bg-background-50 p-4">
                  <p className="font-heading text-2xl font-bold leading-none text-primary-600">{item.value}</p>
                  <p className="mt-2 text-xs leading-snug text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
            <p className="mt-5 text-xs leading-relaxed text-foreground-500">
              Vendas por período, premiação por campanha, produto e canal, contratos elegíveis, não elegíveis e ROI da campanha.
            </p>
          </article>
        </div>

        <div className="mt-6 grid items-center gap-8 overflow-hidden rounded-3xl border border-background-200 bg-background-100 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="relative h-64 md:h-80">
            <img src={SAUDE_ROI_IMG} alt="Dashboard de ROI de campanha de incentivo" className="absolute inset-0 h-full w-full object-cover object-top" />
          </div>
          <div className="p-7 md:p-10">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-bar-chart-2-line"></i>
              ROI da campanha
            </span>
            <h3 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              Não venda só premiação. Venda resultado.
            </h3>
            <div className="mt-6 space-y-3">
              {ROI.map((item) => (
                <div key={item.label} className="flex items-center justify-between rounded-xl border border-background-200 bg-background-50 px-4 py-3">
                  <span className="text-sm font-medium text-foreground-600">{item.label}</span>
                  <span className="font-heading text-sm font-bold text-foreground-950">{item.value}</span>
                </div>
              ))}
            </div>
            <p className="mt-5 text-xs leading-relaxed text-foreground-500">
              Os cálculos e indicadores são definidos conforme os dados que o cliente disponibilizar.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}